import { useState } from "react";
import SearchPageDisplay from "./SearchPageDisplay"
import { Link } from "react-router-dom";
import { useTheme } from "../Theme";

export default function SearchPageResults() {

    const { darkMode, toggleModes } = useTheme();

  const ThemeClasses = darkMode
    ? "bg-slate-800 text-white "
    : "bg-white-800 text-black ";


    // Initial style is cards
    const [displayStyle, setDisplayStyle] = useState('card');

    // Handler to change display according to the button pressed
    // Takes in the format
    const displayHandler = (format) => {

      // Set the style to the passed format
      setDisplayStyle(format);
    }

    const searchData = [
        { name: "Company Name 1", thumbnail: "hackathon.png", categories: ["Category 1", "Category 2", "Category 3"], fav: "Add to Favourites", desc: "Company Description" },

        { name: "Company Name 2", thumbnail: "webinar.jpg", categories: ["Category 1", "Category 2", "Category 3"], fav: "Add to Favourites", desc: "Company Description" },

        { name: "Company Name 3", thumbnail: "online-debate.jpg", categories: ["Category 1", "Category 2", "Category 3"], fav: "Add to Favourites", desc: "Company Description" },

        { name: "Company Name 4", thumbnail: "board.png", categories: ["Category 1", "Category 2", "Category 3"], fav: "Add to Favourites", desc: "Company Description" },

        { name: "Company Name 5", thumbnail: "about-events.png", categories: ["Category 1", "Category 2", "Category 3"], fav: "Add to Favourites", desc: "Company Description" },

    ]

    const ListView = ({company}) => {

        return (
            <>
            
                <tr class="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                    <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">

                        <Link
                            to="/productDetails"
                        >
                            <h5 class="font-medium tracking-tight text-white dark:text-dark">{company.name}</h5>
                        </Link>

                    </th>
                    <td class="px-6 py-4">
                        <span type="button" class="inline-flex text-white border border-gray-300 font-medium rounded-full text-xs px-3 py-1 text-center me-2">{company.categories[0]}</span>
                        <span type="button" class="inline-flex text-white border border-gray-300 font-medium rounded-full text-xs px-3 py-1 me-2">{company.categories[1]}</span>
                        <span type="button" class="inline-flex text-white border border-gray-300 font-medium rounded-full text-xs px-3 py-1 me-2">{company.categories[2]}</span>
                    </td>
                    <td class="px-6 py-4">
                        <p class="font-normal text-gray-700 dark:text-gray-400">{company.desc}</p>
                    </td>
                    <td class="px-6 py-4">
                        <a href="/productDetails" class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-white rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-red-700 dark:hover:bg-red-600 dark:focus:ring-blue-800">
                        {company.fav}
                        </a>
                    </td>
                </tr>
                 
            </>
        )
    }

    const CardView = ({company}) => {

        return (
            <>
                {/* Cards */}

                <div class="w-[250px] bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 hover:shadow-lg transition-transform transform hover:-translate-y-1">

                    <Link
                        to="/productDetails"
                    >
                        <img class="h-[100px] w-full rounded-t-lg" src={`${process.env.PUBLIC_URL}/assets/images/${company.thumbnail}`} alt="" />
                    </Link>
                    
                    <div class="p-5">
                        <a href="#">
                            <h5 class="mb-2 text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{company.name}</h5>
                        </a>

                        <span type="button" class="inline-flex text-white border border-gray-300 font-medium rounded-full text-xs px-3 py-1 text-center me-2 mb-2">{company.categories[0]}</span>
                        <span type="button" class="inline-flex text-white border border-gray-300 font-medium rounded-full text-xs px-3 py-1 text-center me-2 mb-2">{company.categories[1]}</span>
                        <span type="button" class="inline-flex text-white border border-gray-300 font-medium rounded-full text-xs px-3 py-1 text-center me-2 mb-2">{company.categories[2]}</span>


                        <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">{company.desc}</p>
                        <a href="#" class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-red-700 bg-white rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-white dark:hover:bg-gray-100 dark:focus:ring-blue-800">
                            {company.fav}
                        </a>
                    </div>
                </div>

            </>
        )
    }

    return (
        <>
            <div className="content flex-1">

                <div className="content flex justify-between">
                    <div className="content">
                        <h1 className={`text-3xl font-medium text-qblack mb-2.5 ${ThemeClasses}`}>234 Results for "Company"</h1>
                    </div>

                    <div className="ButtonsContainer flex gap-4 left-[80%] top-[0px] transform -translate-x-1/2  md:left-[500px] lg:left-[700px] xl:left-[800px] gap-4">

                        <div
                            className={`Button w-20 h-12 px-6 py-3.5 rounded-lg shadow justify-center items-center gap-2 flex cursor-pointer ${displayStyle === "card" ? 'bg-sky-800' : 'bg-white border border-black'}`}
                            onClick={() => displayHandler("card")}
                        >
                            <div className={`Card text-base font-medium font-['Inter'] leading-normal ${displayStyle === "card" ? 'text-white' : 'text-black'}`}>Card</div>
                            </div>
                        
                        <div
                            className={`Button w-20 h-12 px-6 py-3.5 rounded-lg shadow justify-center items-center gap-2 flex cursor-pointer ${displayStyle === "list" ? 'bg-sky-800' : 'bg-white border border-black'}`}
                            onClick={() => displayHandler("list")}
                        >

                            <div className={`List text-base font-medium font-['Inter'] leading-normal ${displayStyle === "list" ? 'text-white' : 'text-black'}`}>List</div>
                            </div>
                        </div>
                    </div>

                    <hr />

                    {displayStyle == "list" ? (
                        <div className="List w-200 h-auto left-[50px] top-[70px] flex-col justify-start items-start inline-flex cursor-pointer "> 
                            <div className="List h-12 flex-col sm:h-70 left-0 sm:left-[50px] top-[70px] justify-start items-start flex">
                                
                            </div>

                            <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                                <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                    <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                        <tr>
                                            <th scope="col" class="px-6 py-3">
                                                Company name
                                            </th>
                                            <th scope="col" class="px-6 py-3">
                                                Categories
                                            </th>
                                            <th scope="col" class="px-6 py-3">
                                                Summary
                                            </th>
                                            <th scope="col" class="px-6 py-3">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {searchData.map((company, index) => (
                                        <ListView key={index} company={company} />

                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        
                    ) : 
                    
                    (
                        <div className="CardGrid content py-5 grid grid-cols-3 gap-5">
                            {searchData.map((company, index) => (
                                <CardView key={index} company={company} />

                            ))}
                        </div>

                    )}

                {/* Display the search result in the style according to the current displayStyle state */}
                {/* <SearchPageDisplay
                    format = {displayStyle}>
                </SearchPageDisplay> */}

            </div>
        </>
    )
}